import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/utils';
import { 
    LayoutDashboard, 
    Building2, 
    Users, 
    LogOut,
    ChevronLeft,
    ChevronRight,
    ClipboardList,
    UserCog,
    Landmark,
    BarChart3,
    Calendar,
    FileSpreadsheet,
    RefreshCw
} from 'lucide-react';
import { Button } from '../ui/button';
import { useState } from 'react';

export const Sidebar = () => {
    const { user, logout, isAdmin, isDirection, hasConsolidatedAccess } = useAuth();
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const navItems = [
        {
            label: 'Briefing du jour',
            icon: Calendar,
            href: '/briefing',
            show: true
        },
        {
            label: 'Ventes générales',
            icon: LayoutDashboard,
            href: '/dashboard',
            show: true
        },
        {
            label: 'Ventes détaillées',
            icon: ClipboardList,
            href: '/ventes-detaillees',
            show: true
        },
        {
            label: 'Pilotage effectifs',
            icon: UserCog,
            href: '/effectifs',
            show: true
        },
        {
            label: 'Marketing',
            icon: BarChart3,
            href: '/marketing',
            show: true
        },
        {
            label: "Compte d'exploitation",
            icon: FileSpreadsheet,
            href: '/exploitation',
            show: true  // Visible pour tous
        },
        {
            label: "KPI",
            icon: BarChart3,
            href: '/kpi',
            show: true  // Visible pour tous
        },
        // Comptes bancaires - désactivé temporairement (en attente API GoCardless)
        // {
        //     label: 'Comptes bancaires',
        //     icon: Landmark,
        //     href: '/bank',
        //     show: isAdmin || isDirection
        // },
        {
            label: 'Utilisateurs',
            icon: Users,
            href: '/admin/users',
            show: isAdmin
        },
        {
            label: 'Synchronisation',
            icon: RefreshCw,
            href: '/admin-import',
            show: isAdmin
        }
    ];

    return (
        <aside 
            className={cn(
                "sidebar h-screen bg-card border-r border-border flex flex-col transition-all duration-300",
                collapsed ? "w-16" : "w-64"
            )}
            data-testid="sidebar"
        >
            {/* Header */}
            <div className="h-16 border-b border-border flex items-center justify-center px-4">
                {!collapsed && (
                    <img 
                        src="/logos/all4you.png" 
                        alt="All4You" 
                        className="h-10 object-contain"
                    />
                )}
                {collapsed && (
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => setCollapsed(!collapsed)}
                        className="shrink-0"
                        data-testid="sidebar-toggle"
                    >
                        <ChevronRight className="w-4 h-4" />
                    </Button>
                )}
            </div>
            {!collapsed && (
                <div className="flex justify-end px-2 py-1">
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => setCollapsed(!collapsed)}
                        className="shrink-0"
                        data-testid="sidebar-toggle"
                    >
                        <ChevronLeft className="w-4 h-4" />
                    </Button>
                </div>
            )}

            {/* Navigation */}
            <nav className="flex-1 py-4 px-2 space-y-1">
                {navItems.filter(item => item.show).map((item) => (
                    <NavLink
                        key={item.href}
                        to={item.href}
                        className={({ isActive }) => cn(
                            "flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors",
                            "hover:bg-muted",
                            isActive 
                                ? "bg-primary text-primary-foreground hover:bg-primary/90" 
                                : "text-muted-foreground"
                        )}
                        data-testid={`nav-${item.href.replace('/', '')}`}
                    >
                        <item.icon className="w-5 h-5 shrink-0" />
                        {!collapsed && <span className="truncate">{item.label}</span>}
                    </NavLink>
                ))}
            </nav>

            {/* User section */}
            <div className="border-t border-border p-4">
                {!collapsed && (
                    <div className="mb-3">
                        <p className="text-sm font-medium truncate">{user?.name}</p>
                        <p className="text-xs text-muted-foreground truncate">{user?.email}</p>
                    </div>
                )}
                <Button
                    variant="outline"
                    size={collapsed ? "icon" : "default"}
                    onClick={handleLogout}
                    className="w-full"
                    data-testid="logout-button"
                >
                    <LogOut className="w-4 h-4" />
                    {!collapsed && <span className="ml-2">Déconnexion</span>}
                </Button>
            </div>
        </aside>
    );
};

export default Sidebar;
